<template>
  <div>
    <template v-if="!editor">
      <p class="title">帮助中心</p>
      <zt-button type="primary" class="btn" @click="addArticle">添加文章</zt-button>
      <el-table :data="table" size="medium" v-loading="loading.table" empty-text="-暂无文章-">
        <el-table-column label="id" prop="id" />
        <el-table-column label="标题" prop="title" width="230px"/>
        <el-table-column label="发布时间" prop="add_time" />
        <el-table-column label="最后修改时间">
          <template slot-scope="{row}">
            {{row.update_time||row.add_time}}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="90px">
          <template slot-scope="{ row }">
            <zt-button
              size="mini"
              @click="replaceTop(row)"
              v-if="row.order_id==1"
            >取消置顶</zt-button>
            <zt-button size="mini" @click="top(row)" v-else>置顶</zt-button>
            <zt-button size="mini" @click="edit(row)">编辑</zt-button>
            <zt-button size="mini" @click="del(row)">删除</zt-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="pagination">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagination.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.recordcount"
        ></el-pagination>
      </div>
    </template>
    <article-edit v-else :isNew="isNew" @back="back" :article="article"></article-edit>
  </div>
</template>

<script>
import articleEdit from './components/articleEdit';
import {
  taoke_cms_help_delete,
  taoke_cms_help_order_set_top,
  // taoke_cms_help_order_set,
  taoke_cms_help_list,
  taoke_cms_help_order_set_notop
} from '@/api/article';

export default {
  components: {
    articleEdit,
  },
  data: () => ({
    editContent: '',
    editor: false,
    isNew: true,
    article: {
      id: '',
      content: '',
      title: '',
    },
    table: [
    ],
    // 分页器
    pagination: {
      page: 1, // 当前页
      pagesize: 10, // 每页大小
      pagecount: 1, // 总页数
      recordcount: 40, // 总条数
    },
    // loading 状态
    loading: {
      table: false,
    },
  }),
  methods: {
    // 切换页面大小
    onSizeChange(pagesize) {
      this.pagination.pagesize = pagesize;
      this.getList();
    },

    // 切换页面
    onCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    //重排数组
    compare() {
      return function(a, b) {
        var val1 = a['order_id'];
        var val2 = b['order_id'];
        return val1 - val2;
      };
    },
    //获取列表数据
    getList() {
      this.loading.table = true;
      let data = {
        page: this.pagination.page,
        pagesize: this.pagination.pagesize,
      };
      taoke_cms_help_list(data).then(({ data }) => {
        this.table = data.list;
        this.table.map((arr, idx) => {
          if(arr.order_id==null) {
            this.table[idx].order_id = 99999
          }
        })
        this.table.sort(this.compare());
        this.pagination.recordcount = data.recordcount;
        this.pagination.pagecount = data.pagecount;
        this.loading.table = false;
      });
    },

    //添加文章
    addArticle() {
      (this.isNew = true), (this.editor = true);
    },

    //取消置顶
    replaceTop(row) {
      taoke_cms_help_order_set_notop({ id: row.id }).then(({ data }) => {
        if (data.error_code == 0) {
          this.$message.success('取消置顶成功');
          this.getList();
        } else {
          this.$message.error(data.error_message);
        }
      });
    },

    //置顶
    top(row) {
      taoke_cms_help_order_set_top({ id: row.id }).then((res) => {
        if (res.data.error_code == 0) {
          this.$message.success('文章置顶成功');
          this.getList();
        } else {
          this.$message.error(res.data.error_message);
        }
      });
    },

    //编辑
    edit(row) {
      this.isNew = false;
      this.editor = true;
      this.article = row;
    },

    //删除
    del(row) {
      this.$confirm('是否要删除文章', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          taoke_cms_help_delete({ id: row.id }).then(({ data }) => {
            if (data.error_code == 0) {
              this.$message.success('删除文章成功');
              this.getList();
            } else {
              this.$message.error(data.error_message);
            }
          });
        })
        .catch(() => {});
    },

    //返回
    back() {
      this.editor = false;
      //刷新数据
      this.getList()
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
  margin-bottom: 20px;
}
.btn {
  margin-bottom: 10px;
}
.pagination {
  text-align: center;
  margin-top: 20px;
}
</style>


